var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviusPageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92907 2.04363C8.33359 1.65485 8.3365 1.02169 7.93558 0.629429C7.53465 0.237166 6.8817 0.234342 6.47718 0.62312L4.00942 2.99484C3.07996 3.88809 2.32031 4.61816 1.78158 5.26865C1.22136 5.94509 0.815831 6.63167 0.7075 7.45582C0.66 7.81719 0.66 8.18289 0.7075 8.54426C0.815831 9.36841 1.22136 10.055 1.78158 10.7314C2.32031 11.3819 3.07995 12.112 4.00941 13.0052L6.47718 15.377C6.8817 15.7657 7.53465 15.7629 7.93557 15.3707C8.3365 14.9784 8.33359 14.3452 7.92907 13.9565L5.50499 11.6267C4.52118 10.6812 3.84633 10.0305 3.38969 9.4791C2.94612 8.94351 2.79395 8.59948 2.75345 8.29138C2.72802 8.09792 2.72802 7.90216 2.75345 7.7087C2.79395 7.4006 2.94612 7.05657 3.38969 6.52098C3.84633 5.96961 4.52118 5.31889 5.50499 4.37337L7.92907 2.04363Z",
    fill: "#020808"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviusPageIcon);
export default __webpack_public_path__ + "static/media/previusPageIcon.039ff896ac7a9470ab2223d8ba6ffe02.svg";
export { ForwardRef as ReactComponent };